import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "c-alert-content" }
const _hoisted_2 = { class: "c-alert-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "c-alert-body-wrapper" }
const _hoisted_5 = { class: "c-alert-body" }
const _hoisted_6 = { class: "c-alert-message PingFangSC-Medium font-18" }
const _hoisted_7 = { class: "c-alert-icon" }
const _hoisted_8 = ["src"]

import { AlertState } from '@/hooks/use-alert'
import { namedImages } from '@/store'
import { computed } from 'vue'

// eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'CAlert',
  props: {
  state: Object as () => AlertState
},
  emits: ['close', 'confirm', 'trigger-other-action'],
  setup(__props, { emit: __emit }) {

const emit = __emit

// eslint-disable-next-line no-undef
const props = __props

const isEndsWithSymbol = computed(() => props.state?.tips?.endsWith('。'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'c-alert': true, visible: __props.state?.visible })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "c-alert-closer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, [
          _createElementVNode("img", {
            src: _unref(namedImages).icon_cross
          }, null, 8, _hoisted_3)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.state?.message), 1),
          _createElementVNode("div", _hoisted_7, [
            (__props.state?.icon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.state.icon
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["c-alert-tips PingFangSC-Regular", { 'offset-x': isEndsWithSymbol.value }])
          }, _toDisplayString(__props.state?.tips), 3)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["c-alert-footer", { 'multi-buttons': __props.state?.otherActionText }])
      }, [
        (__props.state?.otherActionText)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", {
                class: "c-alert-button left flex-center PingFangSC-Regular",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('trigger-other-action')))
              }, _toDisplayString(__props.state.otherActionText), 1),
              _createElementVNode("div", {
                class: "c-alert-button right flex-center PingFangSC-Regular",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm')))
              }, _toDisplayString(__props.state.buttonText), 1)
            ], 64))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "c-alert-button flex-center PingFangSC-Regular",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('confirm')))
            }, _toDisplayString(__props.state?.buttonText), 1))
      ], 2)
    ])
  ], 2))
}
}

})